import { useHistory } from "react-router-dom"
import { useTableErrorConfig } from "../../../../../../../_webui/layout/components/Table/Error/modules/useTableErrorConfig"
import { useApi } from "../useApi"
import { useTableConfig } from "../useTableConfig"
import { useVariablesAuthority } from "../useVariablesAuthority"
import { useVariablesModal } from "../useVariablesModal"

export const useVariables = () => {
  const { push } = useHistory()
  const { columnErrors } = useTableErrorConfig()
  const { columns } = useTableConfig()

  const {
    isNotAccessScreen,
    isRoleAdmin,
    isVisibleBtnCancel,
    isVisibleBtnDelete,
  } = useVariablesAuthority()

  const {
    isOpen,
    isOpenDeleted,
    onCancel,
    onCancelDeleted,
    onOpen,
    onOpenDeleted,
  } = useVariablesModal()
  const {
    beforeUpload,
    bulkCheck,
    bulkDelete,
    bulkDeleteData,
    bulkFileDelete,
    bulkRequestDelete,
    countRecord,
    dataTemps,
    errorList,
    fileNameList,
    isDisabledSubmit,
    isLoading,
    isLoadingLayout,
    isResetTable,
    onChange,
    perItem,
    setIsLoading,
  } = useApi({
    onCancel,
    onCancelDeleted,
  })

  return {
    beforeUpload,
    bulkCheck,
    bulkDelete,
    bulkDeleteData,
    bulkFileDelete,
    bulkRequestDelete,
    columnErrors,
    columns,
    countRecord,
    dataTemps,
    errorList,
    fileNameList,
    isDisabledSubmit,
    isLoading,
    isLoadingLayout,
    isNotAccessScreen,
    isOpen,
    isOpenDeleted,
    isResetTable,
    isRoleAdmin,
    isVisibleBtnCancel,
    isVisibleBtnDelete,
    onCancel,
    onCancelDeleted,
    onChange,
    onOpen,
    onOpenDeleted,
    perItem,
    push,
    setIsLoading,
  }
}
